import { Box } from '@mui/material';
import { useGumstack } from '@/hooks/useGumstack';
import { LencoImage } from '@/atomic-components/Image';

const VideoCallBanner = () => {
	const { launchGumstack } = useGumstack();

	return (
		<Box onClick={launchGumstack}>
			<LencoImage
				containerSx={{
					height: '257px',
					width: '100%',
				}}
				url='https://assets.furlenco.com/s3-furlenco-images/2.0/web-apps/video-call-banner-desktop-pdp.jpg'
			/>
		</Box>
	);
};

export default VideoCallBanner;
